import React, { useState, useEffect, useRef } from "react";
import { Link } from "gatsby";
import PropTypes from "prop-types";
import styled from "styled-components";
import { colors, fonts } from "../../utils/variables";
import breakpoints from "../../utils/breakpoints";
import { navigationLinks } from "../../utils/menuLinks";
import Arrow from "../../assets/icons/arrow-right.svg";

const StyledContainer = styled.div`
  .menu__content {
    width: 92vw;
    padding: 20px 15px 0px 15px;
    overflow-x: hidden;
    ${breakpoints.medium`
      width: 100%;
      height: 100% !important;
      display: flex;
      justify-content: end;
      align-items: center;
      padding: 0;
    `}
    button {
      font-family: ${fonts.primary} !important;
      cursor: pointer;
    }
    svg {
      margin-right: 4px;
      path {
        stroke: ${colors.charcoal};
      }
    }
    ul {
      margin: 0;
    }
    li {
      margin-bottom: 18px;
      a,
      button {
        width: auto;
        display: inline-flex;
        flex-direction: column;
        align-items: start;
        justify-content: center;
        text-decoration: none;
        text-align: left;
        font-size: 24px;
        padding: 0;
        color: ${colors.salmon};
        ${breakpoints.medium`
          font-size: 16px;
          color: white;
          &:hover {
            color: ${colors.salmon};
          }
        `}
        ${breakpoints.large`
          font-size: 18px;
        `}
      }
      ${breakpoints.medium`
        margin-right: 18px;
        margin-bottom: 0;
      `}
      ${breakpoints.large`
        margin-right: 24px;
        margin-bottom: 0;
      `}
      &:last-child {
        margin-right: 30px;
      }
    }
  }
  a {
    white-space: nowrap;
  }
  .menu__link {
    display: flex;
    align-items: center;
    &.rotate {
      svg {
        transform: rotate(180deg);
        transition: all 0.3s ease;
      }
    }
    svg {
      path {
        stroke: ${(props) =>
    props.$backgroundColor !== `${colors.charcoal}`
      ? `${colors.charcoal}`
      : `${colors.salmon}`};
      }
    }
  }

  .boton {
    position: relative;
    height: auto;
    padding: 0;
    white-space: nowrap;
    ${breakpoints.medium`
      height: 80px;
    `}
  }

  .boton-category {
    position: relative;
    height: auto;
    padding: 8px 0;
    white-space: nowrap;
    color: ${colors.salmon__500} !important;
    font-size: 21px !important;
    ${breakpoints.medium`
      color: ${colors.salmon} !important;
      padding: 6.5px 0;
      font-size: 18px !important;
      height: 30px;
      &:hover {
        color: ${colors.salmon__500} !important;
      }
    `}
  }

  .arrow {
    transform: rotate(270deg);
    color: ${colors.salmon__500} !important;
    ${breakpoints.medium`
        transform: rotate(180deg);
        `}
  }

  .dropdown-menu {
    width: 94% !important;
    height: auto;
    padding: 0;
    padding-top: 10px;
    position: relative;
    top: 100%;
    display: flex;
    flex-direction: column;
    align-items: start;
    overflow: hidden;
    ${breakpoints.medium`
      position: absolute;
      width: auto !important;
      min-width: unset;
      max-height: 900px;
      padding: 20px;
      top: 100%;
      border: .3px solid rgba(0,0,0,.3);
      border-top: none;
      background: ${colors.charcoal};
      z-index: 100;
      overflow: visible;
    `}
  }

  .dropdown-menu-prof {
    width: 94% !important;
    height: auto;
    padding: 0;
    padding-top: 10px;
    position: relative;
    top: 100%;
    display: flex;
    flex-direction: column;
    align-items: start;
    overflow: hidden;
    ${breakpoints.medium`
      position: absolute;
      width: 280px !important;
      max-height: 900px;
      padding: 20px;
      top: 100%;
      border: .3px solid rgba(0,0,0,.3);
      border-top: none;
      background: ${colors.charcoal};
      z-index: 100;
      overflow: visible;
    `}
  }

  .dropdown-links {
    width: 100% !important;
    height: auto;
    padding: 6px 0;
    position: relative;
    top: 100%;
    display: flex;
    flex-direction: column;
    align-items: start;
    overflow: hidden;
    ${breakpoints.medium`
      position: absolute;
      width: auto !important;
      min-width: unset;
      max-height: 900px;
      padding: 20px 60px 20px 20px;
      top: 0;
      left: 100%;
      border: .3px solid rgba(0,0,0,.3);
      border-top: none;
      background: ${colors.charcoal} !important;
      z-index: 100;
      overflow: visible;
    `}
  }

  .dropdown-profesionales {
    width: 100% !important;
    height: auto;
    padding: 0;
    position: relative;
    top: 100%;
    display: flex;
    flex-direction: column;
    align-items: start;
    overflow: hidden;
  }

  .dropdown-item-prof {
    width: 100% !important;
    padding: 4.5px 0 !important;
    font-size: 18px !important;
    text-decoration: none;
    text-align: left;
    color: white !important;
    opacity: 0.9;
    overflow: hidden !important;
    white-space: nowrap;
    ${breakpoints.medium`
      font-size: 16px !important;
      padding: 6px 0 !important;
      letter-spacing: 0.6px;
      opacity: 1;
      &:hover {
        color: ${colors.salmon} !important;
      }
    `}
  }

  .arrow-prof {
    transform: rotate(270deg);
    color: ${colors.salmon__500} !important;
  }

  .dropdown-item {
    width: 100% !important;
    padding: 4.5px 0 !important;
    font-size: 18px !important;
    text-decoration: none;
    text-align: left;
    color: white !important;
    opacity: 0.9;
    overflow: hidden !important;
    white-space: nowrap;
    ${breakpoints.medium`
      font-size: 16px !important;
      padding: 8px 0 !important;
      letter-spacing: 0.6px;
      opacity: 1;
      &:hover {
        color: ${colors.salmon} !important;
      }
    `}
  }
`;

const NavigationLinks = ({ backgroundColor, closeMenu }) => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [openSubcategory, setOpenSubcategory] = useState(null);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setOpenDropdown(null);
        setOpenSubcategory(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const links = navigationLinks();

  const toggleDropdown = (name) => {
    setOpenDropdown((prev) => {
      if (prev === name) return null;
      setOpenSubcategory(null);
      return name;
    });
  };

  const toggleSubcategory = (category) => {
    setOpenSubcategory((prev) => (prev === category ? null : category));
  };

  return (
    <StyledContainer ref={containerRef}>
      <nav aria-label="Main navigation">
        <ul className="menu__content">
          {links.map(({ name, categories, posts, url, submenu }) => (
            <li key={name}>
              {categories || submenu ? (
                <Link
                to="#"
                onClick={(e) => {
                  e.preventDefault();
                  toggleDropdown(name);
                }}
                className={
                  backgroundColor !== colors.charcoal
                    ? "boton text--s color-hover--charcoal"
                    : "boton text--s color-hover--salmon"
                }>
                  {name.charAt(0).toUpperCase() + name.slice(1)}
                </Link>
              ) : (
                <Link
                to={url}
                onClick={closeMenu}
                className={
                  backgroundColor !== colors.charcoal
                    ? "text--s color-hover--charcoal"
                    : "text--s color-hover--salmon"
                }
                aria-label={`Ir a la página de ${name}`}
                >
                  {name}
                </Link>
              )}

              {openDropdown === name && categories && (
                <div
                  className="dropdown-menu"
                  aria-label={`Abrir categorías de ${name}`}
                >
                  {categories.map((category) => (
                    <div key={category}>
                      <Link
                        to="#"
                        onClick={(e) => {
                         e.preventDefault();
                         toggleSubcategory(category)}}
                        className="text--s"
                        aria-label={`Ver posts de la categoría ${category}`}
                      >
                        <span className="boton-category d-flex align-items-center">
                          {category}{" "}
                          <img src={Arrow} alt="Arrow icon" className="arrow" />
                        </span>
                      </Link>
                      {openSubcategory === category && (
                        <div
                          className="dropdown-links"
                          aria-label={`Posts en ${category}`}
                        >
                          {(posts || [])
                            .filter((post) =>
                              Array.isArray(post.categorias)
                                ? post.categorias.includes(category)
                                : post.categorias === category
                            )
                            .map((filteredPost) => (
                              <Link
                                key={filteredPost.slug}
                                to={`${url}${filteredPost.slug}`} 
                                className="dropdown-item"
                                aria-label={`Ir a la página del post ${filteredPost.title}`}
                              >
                                {filteredPost.title}
                              </Link>
                            ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
              {openDropdown === name && submenu && (
                  <div className="dropdown-menu-prof">
                    {submenu.map((item) => (
                      <div key={item.name}>
                        {item.sublinks ? (
                          <>
                            <Link 
                              to="#" 
                              onClick={(e) => {
                                e.preventDefault();
                                toggleSubcategory(item.name);
                              }} 
                              className="text--s"
                            >
                              <span className="boton-category d-flex align-items-center">
                                {item.name}{" "}
                                <img src={Arrow} alt="Arrow icon" className="arrow-prof" />
                              </span>
                            </Link>
                            {openSubcategory === item.name && (
                              <div className="dropdown-profesionales">
                                {item.sublinks.map((sublink) => (
                                  <Link 
                                    key={sublink.url} 
                                    to={sublink.url} 
                                    className="dropdown-item-prof"
                                    aria-label={`Ir a la página de ${sublink.name}`}
                                    >
                                    {sublink.name}
                                  </Link>
                                ))}
                              </div>
                            )}
                          </>
                        ) : (
                          <Link 
                          key={item.url} 
                          to={item.url} 
                          className="boton-category text--s"
                          aria-label={`Ir a la página de ${item.name}`}>
                            {item.name}
                          </Link>
                        )}
                      </div>
                    ))}
                  </div>
                )}

            </li>
          ))}
        </ul>
      </nav>
    </StyledContainer>
  );
};

NavigationLinks.propTypes = {
  backgroundColor: PropTypes.string,
  closeMenu: PropTypes.func,
};

export default NavigationLinks;
